module.exports = __webpack_public_path__ + "Enrollment Template.xlsx";